import { decrypt } from "./secret";

let lPK;
let lPKPromise;

const key = "kkqwehuo";

const getWasmUrl = () => {
  // 使用绝对路径，避免 hash 路由或深层路径下相对地址找错文件
  const base = (typeof process !== "undefined" && process.env && process.env.BASE_URL) || "/";
  const prefix = base.endsWith("/") ? base : `${base}/`;
  return `${prefix}prek.wasm`;
};

const loadWasm = async () => {
  if (typeof WebAssembly === "undefined" || !WebAssembly) {
    throw new Error("当前浏览器不支持 WebAssembly，无法完成请求签名");
  }
  if (typeof WebAssembly.Memory !== "function") {
    throw new Error("当前环境 WebAssembly.Memory 不可用");
  }

  let memory;
  try {
    memory = new WebAssembly.Memory({ initial: 256 });
  } catch (e) {
    // 微信等弱内存环境可能无法分配 initial:256（约 16MB）
    throw new Error("当前设备内存不足，请关闭其他应用后重试");
  }
  const envStub = {
    memory,
    emscripten_resize_heap: () => 0,
    _emscripten_memcpy_js: (d, s, n) => {
      const mem = new Uint8Array(memory.buffer);
      mem.set(mem.subarray(s, s + n), d);
      return d;
    },
    _abort_js: () => {},
    abort: () => {}
  };
  const wasiStub = {
    proc_exit: () => {},
    fd_close: () => 0,
    fd_write: () => 0,
    fd_seek: () => 0,
    fd_fdstat_get: () => 0,
    fd_read: () => 0,
    environ_sizes_get: () => 0,
    environ_get: () => 0,
    clock_res_get: () => 0,
    clock_time_get: () => 0
  };
  const importObject = {
    env: envStub,
    wasi_snapshot_preview1: wasiStub
  };

  const res = await fetch(getWasmUrl());
  if (!res.ok) {
    throw new Error(`prek.wasm 加载失败: ${res.status}`);
  }
  const bytes = await res.arrayBuffer();
  if (!bytes || bytes.byteLength < 8) {
    throw new Error("prek.wasm 内容无效");
  }

  let instance;
  try {
    ({ instance } = await WebAssembly.instantiate(bytes, importObject));
  } catch (e) {
    const msg = (e && e.message) || "";
    if (msg.indexOf("Out of memory") !== -1 || msg.indexOf("allocate") !== -1) {
      throw new Error("当前设备内存不足，请关闭其他应用后重试");
    }
    throw e;
  }
  return { instance, memory };
};

const getKey = async () => {
  const { instance, memory } = await loadWasm();
  if (!instance || !instance.exports || typeof instance.exports.get_hidden_key !== "function") {
    throw new Error("prek.wasm 导出异常");
  }

  const keyPtr = instance.exports.get_hidden_key();
  // 优先用导出 memory，没有则回退到导入的 memory，避免 null.Memory / null.buffer
  const wasmMemory = instance.exports.memory || memory;
  if (!wasmMemory || !wasmMemory.buffer) {
    throw new Error("prek.wasm Memory 不可用");
  }

  const memView = new Uint8Array(wasmMemory.buffer);
  let end = keyPtr;
  while (memView[end] !== 0) end++;
  const keyBytes = memView.slice(keyPtr, end);
  const publicKey = new TextDecoder().decode(keyBytes);
  if (typeof instance.exports.free_key === "function") {
    instance.exports.free_key(keyPtr);
  }
  return publicKey;
};

export const getLPK = async () => {
  if (lPK) return lPK;
  if (!lPKPromise) {
    lPKPromise = getKey()
      .then(k => {
        lPK = k
          .split("\n")
          .map(i => decrypt(i, key))
          .join("\n");
        return lPK;
      })
      .catch(err => {
        lPKPromise = null;
        throw err;
      });
  }
  return lPKPromise;
};
